<template>
  <Modal :id="'cmp-add-current-statements-modal'" @cancelled="onCancel">
    <template slot="header">{{'new_statement'}}</template>

    <template slot="body">
    
        <TextField 
          class="m1" 
          :id="'Year'" 
          required 
          v-bind="textFieldConfig" 
          :value="currentStatement.statement_year" 
          :placeholder="$t('year')" 
          :showValidationIcons="true"
          :immediateValidation="true"
          @valuechanged="onTextFieldValueChange" 
        
        />
        
        <Dropdown 
          :options="periodTV" 
          class="m2" 
          required
          :selected="periodTV.find((x)=>x.value==currentStatement.statement_period_txt)" 
          :placeholder="$t('period')" 
          v-on:selectedChange="(e) => onDropdownChange('statement_period_txt', e)" 
          box 
          :showValidationIcons="true"
          :immediateValidation="true"
          @validated="e => onValidation('statement_period_txt', e)"
        />
        
     
        <Dropdown 
          :options="digitalPhysicalTV" 
          class="m2" 
          required
          :selected="digitalPhysicalTV.find((x)=>x.value==currentStatement.digital_physical)" 
          :placeholder="$t('type_string')" 
          v-on:selectedChange="(e) => onDropdownChange('digital_physical', e)" 
          box 
          :showValidationIcons="true"
          :immediateValidation="true"
          @validated="e => onValidation('digital_physical', e)"
        
       
        />
       
        
        <Dropdown 
          :options="currencyTV" 
          class="m2" 
          required
          :selected="currencyTV.find((x) => x.value == currentStatement.currency_id)" 
          :placeholder="$t('currency')" 
          v-on:selectedChange="(e) => onDropdownChange('currency_id', e)" 
          box 
          :showValidationIcons="true"
          :immediateValidation="true"
          @validated="e => onValidation('currency_id', e)"
        />
        
        <Dropdown 
          :options="invoiceProjectTV" 
          class="m2" 
          required
          :selected="invoiceProjectTV.find((x) => x.value == currentStatement.invoice_project_id)" 
          :placeholder="$t('invoice_project')" 
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)" 
          box 
          :showValidationIcons="true"
          :immediateValidation="true"
          @validated="e => onValidation('currency_id', e)"
        />
       
    </template>
    <template slot="options">
      
      <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button s6 v1"         
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click="onSave"
      >
       {{ $t('ok') }}
      </button>
    </template>
  </Modal>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "../../../../plugins/text-field/input-field";
import AddPerson from "../../../../dt-plugins/add-contact-relation/add-person";
import AddCompany from "../../../../dt-plugins/add-contact-relation/add-company";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import Modal from "../../../../dt-plugins/modal/modal";
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";


import { AccountService } from "../../services/account.service";
import { createTV } from '../../../../models/text-value.model';

export default {
  components: {
    InputField,
    AddPerson,
    AddCompany,
    Modal,
  },
  mixins: [],

  data: function () {
    return {
  
    
      currentStatement: {
        account_id: 0,
        statement_year: "",
        digital_physical:null,
        statement_period_txt: null,
        currency_id: null,
        invoice_project_id: null,
      },

      formData:{},
      validationResult: {},


    };
  },
  mounted:async function () {
    const resFormData = await AccountService.getNewStatement({account_id:this.$route.query.account_id})
    
    this.formData=resFormData.data;
    console.log(":::::::::::",this.$route.query);
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    // return ""
    },
    textFieldConfig: function () {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        // immediateValidation : isChromium() ? false : true,
      };
    },

    digitalPhysicalTV:function(){
      return [
        { text:'Digital' , value:'digital' },
        { text:'Physical' , value:'physical' },
        { text:'Costs' , value:'costs' },
        { text:'Third Party' , value:'thirdparty' },
        { text:'Performance' , value:'performance' },
        { text:'Other Income' , value:'income' },
      ]
    },

    invoiceProjectTV:function(){
      return createTV(this.formData?.invoice_projects,'invoice_project_name','invoice_project_id');
    },

    currencyTV:function(){
      return createTV(this.formData?.currencies,'currency_iso','currency_id');
    },

    periodTV:function(){
      return [
        { text:'M1' , value:'M1' },
        { text:'M2' , value:'M2' },
        { text:'M3' , value:'M3' },
        { text:'M4' , value:'M4' },
        { text:'M5' , value:'M5' },
        { text:'M6' , value:'M6' },
        { text:'M7' , value:'M7' },
        { text:'M8' , value:'M8' },
        { text:'M9' , value:'M9' },
        { text:'M10' , value:'M10' },
        { text:'M11' , value:'M11' },
        { text:'M12' , value:'M12' },
        { text:'Q1' , value:'Q1' },
        { text:'Q2' , value:'Q2' },
        { text:'Q3' , value:'Q3' },
        { text:'Q4' , value:'Q4' },
        { text:'S1' , value:'S1' },
        { text:'S2' , value:'S2' },
        { text:'Y' , value:'Y' },
      ]
    }


  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult,name, value);
    },
    onSave: async function () {
      console.log(this.currentStatement);
      if (this.currentStatement) {
        this.currentStatement.account_id = this.$route.query.account_id;
        this.$emit("added", {...this.currentStatement});
      }
    },
    onDropdownChange: function (name, value) {
      this.currentStatement[name] = value.value;

    },
    onTextFieldValueChange: function (key, value) {
      this.currentStatement.statement_year = value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-add-current-statements-modal{

.dt-modal--body {
  margin-left: 0px;
}


.dt-modal--options {
  justify-content:space-between;
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
}
 
</style>
